<template>
  <HotjarFeedbackButton @click="showModal">
    <span class="hidden md:block">
      {{ t('support.feedback') }}
    </span>
  </HotjarFeedbackButton>

  <HotjarFeedbackModal />
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import HotjarFeedbackModal from '@/components/modals/HotjarFeedbackModal/HotjarFeedbackModal.vue';
import HotjarFeedbackButton from '@/components/ui/HotjarFeedbackButton/HotjarFeedbackButton.vue';
import {NAME} from '@/components/ui/Modal';
import useHotjar from '@/composables/useHotjar';
import {useModal} from '@/composables/useModal';

const {t} = useI18n();
const {openModal} = useModal(NAME.HOTJAR_FEEDBACK);
const {triggerEvent} = useHotjar();

const showModal = () => {
  openModal();
  triggerEvent('start-feedback');
};
</script>
